import SearchBar from "./searchBar"
import Listing from "./listing"
import { useDispatch, useSelector } from "react-redux"
import { useState, useEffect } from "react"
import { getDataBanners, updateBannerStatus, deleteBanner } from "../../services/manage-banner/action"
import AddUpdateBanner from "./addUpdateBanner"
import { getPrivileges } from '../../common/adminPrivilege';
import DeleteModal from "../../common/deleteModal";
import { getAdminPaginationLimit } from "../../../common/common"

const ManageBannerIndex = () => {

    const [bannerId, setBannerId] = useState(false);
    const [formshow, setFormShow] = useState(false);
    const [deleteid, setDeleteId] = useState(null);
    const [deleteshow, setDeleteShow] = useState(false);

    const getPrivilege = getPrivileges();
    const editBanner = getPrivilege.canEditBanner();

    const [currentPage, setCurrentPage] = useState(1);
    const limit = getAdminPaginationLimit();
    const requestBody = {
        page: currentPage,
        limit: limit,
        keyword: "",
        attach_images: true,
    };
    const [filterdata, setFilterData] = useState(requestBody);
    const dispatch = useDispatch()
    const { banners, totalCount, attachments } = useSelector((state) => state.banner)
    const loading = useSelector((state) => state.banner.loading)
    const error = useSelector((state) => state.banner.error)

    useEffect(() => {
        dispatch(getDataBanners(requestBody))
    }, []);

    const handleFormShow = async (id) => {
        try {
            if (typeof id === "number") {
                setBannerId(id);
            }
        } catch (error) { }
        setFormShow(true);
    }
    const handleFormClose = () => {
        setBannerId(false);
        setFormShow(false);
    }
    const handlePaginate = (selectedPage) => {
        const updatedFilterData = {
            ...filterdata,
            page: selectedPage.selected + 1,
        };
        setCurrentPage(selectedPage.selected + 1);
        setFilterData(updatedFilterData);
        dispatch(getDataBanners(updatedFilterData))
    };
    const calculateSerialNumber = (index) => {
        return (currentPage - 1) * limit + index + 1;
    };
    const handleFilterUpdate = async (name, value, boolen) => {
        let updatedFilterData;
        updatedFilterData = {
            ...filterdata,
            [name]: value,
        };
        setFilterData(updatedFilterData);
        if (boolen === true) {
            dispatch(getDataBanners(updatedFilterData))
        }
    };

    const handleStatus = async (e, id, status) => {
        const newStatus = status === 1 ? 0 : 1;
        banners.map((banner) => {
            if (banner.banner_id === id) {
                banner.banner_status = newStatus;
            }
            return banner;
        });
        const data = {
            "status": newStatus,
            "id": [id],
        };
        try {
            await updateBannerStatus(data)
            dispatch(getDataBanners(requestBody));
        } catch (error) { }
    };

    const deleteModalOpen = (id) => {
        setDeleteShow(true);
        setDeleteId(id);
    };

    const handleDeleteClose = () => {
        setDeleteShow(false);
    };

    const handleDelete = async () => {
        try {
            let data;
            if (typeof deleteid === "number") {
                data = [deleteid];
            }
            await deleteBanner({ "banner_id": data });
            dispatch(getDataBanners(requestBody));
            handleDeleteClose();
        } catch (error) { }
    };

    const handleFilter = () => {
        let updatedFilterData = {
            ...filterdata,
            page: 1,
        }
        setCurrentPage(1)
        dispatch(getDataBanners(updatedFilterData));
    };
    const handleClear = () => {
        let updatedFilterData = {
            ...requestBody,
            page: 1,
        }
        setCurrentPage(1)
        setFilterData(updatedFilterData);
        dispatch(getDataBanners(updatedFilterData));
    };

    return (

        <>
            <div className="bg-whites mt-4 pt-5">
                <div className="container-fluid inner-section">
                    <SearchBar
                        handleFilterUpdate={handleFilterUpdate}
                        handleFormShow={handleFormShow}
                        editBanner={editBanner}
                        handleFilter={handleFilter}
                        handleClear={handleClear}
                    />
                    <Listing
                        banners={banners}
                        totalCount={totalCount}
                        loading={loading}
                        error={error}
                        handleFormShow={handleFormShow}
                        handlePaginate={handlePaginate}
                        calculateSerialNumber={calculateSerialNumber}
                        limit={limit}
                        handleStatus={handleStatus}
                        editBanner={editBanner}
                        deleteModalOpen={deleteModalOpen}
                        currentPage={currentPage}
                    />
                </div>
            </div>
            {formshow &&
                <AddUpdateBanner
                    formshow={formshow}
                    handleFormClose={handleFormClose}
                    bannerId={bannerId}
                    requestBody={requestBody}
                    editBanner={editBanner}
                />
            }
            <DeleteModal
                show={deleteshow}
                deleteModalOpen={deleteModalOpen}
                handleDeleteClose={handleDeleteClose}
                handleDelete={handleDelete}
            />
        </>
    )
}
export default ManageBannerIndex